<template lang="html">
  <div id="job-description-page">

    <section class="company-info-section">
      <div class="placed-backg box-banner">
        <div class="container flex-center-xy">
          <div class="inside">
            <h5>Jobusco - resultado</h5>
          </div>
        </div>
      </div>

      <div class="container content">
        <div class="row">
          <div class="col col-company-logo">
            <div class="box">
              <div class="img"><img :src="vacanct.empresa_imageUrl"></div>
            </div>
          </div>

          <div class="col col-company-info">
            <h1 class="title">{{vacanct.nombre}}</h1> 
              <div class="best-companies lg" v-if="vacanct.mejoresempresas == 1">
                <span>
                  <i class="fas fa-star"></i> Mejores Empresas
                </span>
              </div>
              <span style="color: #129f9a;font-size: 30px;padding-left: 29px;cursor: pointer;" @click="saveVacancies" ><i class="fas fa-heart"></i></span>
            <h4 class="company"><router-link :to="'/empresas/'+$root._converToURL(vacanct.empresa,vacanct.usuarios_id)">{{vacanct.empresa}}</router-link></h4>
            <h5 class="location"><i class="icon"></i>{{vacanct.direccion}}, {{vacanct.ciudad}}, {{vacanct.estado}}.</h5>

            <div class="box-job-info">
              <div class="box">
                <i class="fal fa-calendar-alt"></i>
                <span>{{vacanct.fecha}}</span>
              </div>

              <div class="box">
                <i class="far fa-eye"></i>
                <span>{{vacanct.web_views}} Vistas</span>
              </div>

              <div class="box">
                <i class="fal fa-calendar-alt aqua"></i>
                <span>Aplicar antes del {{vacanct.aplicar_antesde}}</span>
              </div>
            </div>

            <div class="box-share">
              <span>Compartir vacante en: </span>
              <div class="col-12 px-0 mb-4 box-sharing">
              <ShareNetwork
                v-for="(network, pdInx) in networks"
                :network="network.network"
                :key="network.network"
                :style="{backgroundColor: network.color}"
                :url="sharing.url"
                :title="sharing.title"
                :description="sharing.description"
                :quote="sharing.quote"
                :hashtags="sharing.hashtags"
                :media="sharing.media"
                :twitter-user="sharing.twitterUser">
                <div class="btn-q"><span><i :class="network.icon"></i></span></div>
              </ShareNetwork>
            </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="container job-description-section">
      <div class="row">

        <!-- Description -->
        <div class="col-lg-8 col-xl-9 col-main-info">
          <div class="content">
            <div class="box-top">
              <div class="col-12 col-sm-6 col-md col-info">
                <h5 class="m-title">Sueldo Ofrecido</h5>
                <h5 class="res">{{vacanct.sueldo}} / {{vacanct.periodo}} </h5>
              </div>

              <div class="col-12 col-sm-6 col-md col-info">
                <h5 class="m-title">Experiencia</h5>
                <h5 class="res">{{vacanct.experiencia}}</h5>
              </div>

              <div class="col-12 col-sm-6 col-md col-info">
                <h5 class="m-title">Sexo</h5>
                <h5 class="res">{{vacanct.genero}}</h5>
              </div>
              <div class="col-12 col-sm-6 col-md col-info">
                <h5 class="m-title">Sector del empleo</h5>
                <h5 class="res">{{vacanct.area}}</h5>
              </div>
            </div>

            <div class="box-description">
              <h5 class="m-title">Descripción de la Vacante</h5>
              <div>
                <p v-html="vacanct.descripcion"></p>

                <!--ul class="check-list">
                  <li>Disponibilidad para rolar turnos.</li>
                  <li>Disponibilidad para viajar.</li>
                </ul-->
              </div>

              <h5 class="m-title">Ofrecemos</h5>
              <p v-html="vacanct.ofrecemos"></p>
                <!--ul class="check-list">
                  <li>Sueldo fijo</li>
                  <li>Comisiones por venta.</li>
                  <li>Prestaciones de Ley.</li>
                </ul-->

              <h5 class="m-title">Habilidades</h5>
              <div class="box-bubbles">
                <div class="bubble" v-for="habilidad in vacanct.habilidades" :key="habilidad.id">{{habilidad.nombre}}</div>

              </div>
              <h5 class="m-title">Otros requisitos</h5>
              <div class="box-bubbles">
                <ul>
                  <li><b>Nivel de estudios:</b> {{vacanct.nivel_estudios}}</li>
                  <li><b>Requisito especial:</b> {{vacanct.requisito_especial}}</li>
                </ul>


              </div>
            </div>
          </div>
        </div>
        <!--  -->

        <!-- Sidebar -->
        <div class="col-lg-4 col-xl-3 col-buttons">
          <a class="f-w-700 btn-squ-cur-1 xl" @click="savePostulate()" v-if="$root.type_logged != 'empresa'">POSTULARME</a>
          <br><br><br>
          <!-- <h6>Aplicar antes del {{vacanct.aplicar_antesde}}</h6> -->

          <div >
            <div class="box-el-title">
              <h3>Formulario de contacto</h3>
            </div>

            <b-form @submit="onSubmitContact">
              <b-form-group label="Nombre:" label-for="i-1">
                <b-form-input
                  id="i-1"
                  v-model="contactForm.name"
                  type="text"
                  placeholder="Ingresa tu nombre"
                  required
                ></b-form-input>
              </b-form-group>

              <b-form-group label="Correo Electrónico:" label-for="i-2">
                <b-form-input
                  id="i-2"
                  v-model="contactForm.email"
                  type="email"
                  placeholder="Ingresa tu correo electrónico"
                  required
                ></b-form-input>
              </b-form-group>

              <b-form-group label="Número Telefónico:" label-for="i-3">
                <b-form-input
                  id="i-3"
                  v-model="contactForm.phone"
                  type="text"
                  placeholder="Ingresa tu número telefónico"
                  maxlength="10"
                  minlength="10"
                  required
                ></b-form-input>
              </b-form-group>

              <b-form-group label="Mensaje:" label-for="i-4">
                <b-form-textarea
                  id="i-4"
                  v-model="contactForm.msg"
                  placeholder="Escriba el mensaje aquí"
                  rows="5"
                  max-rows="5"
                ></b-form-textarea>
              </b-form-group>

              <p>
                <b-form-checkbox
                  v-model="contactForm.checkbox"
                  name="checkbox-1"
                  value="1"
                  unchecked-value="0"
                  required>
                  Al hacer clic en la casilla de verificación, acepta nuestros Términos y condiciones y Política de privacidad
                </b-form-checkbox>
              </p>

              <p class="mt-3">
                <b-button type="submit" class="btn-squ-cur-1 xl blue w-100">ENVIAR MENSAJE</b-button>
              </p>
            </b-form>
          </div>

          <!-- <div class="box-return">
            <router-link class="_btn" to=""><i class="fas fa-undo icon"></i> Seguir buscando</router-link>
          </div> -->
        </div>
        <!--  -->

      </div>
    </section>

    <section class="container related-section">
      <div class="box-title">
        <h3>También puede interesante esta vacante</h3>
      </div>

      <div class="row results-container">

        <div class="col-lg-9 col-jobs-s1" v-for="(job, hjbInx) in vacanct.related" :key="'hjbInx-'+hjbInx">
          <router-link class="box" :to="'/empleos/'+job.id">
            <div class="col col-logo">
              <img :src="job.empresa_imageUrl">
            </div>

            <div class="col col-info">
              <h4 class="title">{{ job.nombre }}</h4>
              <h5 class="company">{{ job.empresa }}</h5>
              <h5 class="location">{{ job.ciudad }}, {{ job.estado }}.</h5>
            </div>

            <div class="col col-time">
              <h6 class="date">{{job.fecha}}</h6>
              <!-- <span class="type completo" v-bind:style="{ backgroundColor: job.typeColor }">{{ job.type }}</span> -->
            </div>
          </router-link>
        </div>

      </div>
    </section>
    <sweet-modal ref="modalLoading" hide-close-button blocking>

        <img src="/public/images/shared/loading.gif" width="30%">
        <p style="text-align: center;"><b>Cargando...</b></p>
    </sweet-modal>
    <sweet-modal :icon="modal.icon" ref="modalAlert">
          {{modal.msg}}
          <br><br>
          <a class="btn btn-info" @click="$refs.modalAlert.close()">Aceptar</a>
      </sweet-modal>

  </div>
</template>

<script type="text/javascript">
  export default {
    data(){
      return {

        vacanct:{

        },
        id:"",
        modal:{
          icon:null,
          msg:null
        },
        contactForm: {

        },
        day_now:null,
         // == Sharing ==
        urlPage: 'https://jobusco.com/#/empleos/',
        sharing: { // ¡CUIDADO! Este object es usado por VUE-META y por el plugin para compartir.
          url: '',
          title: 'Vacante',
          description: '',
          hashtags: '',
          keywords: 'empleos, jobusco',
          twitterUser: 'jobuscomx',
          media: 'https://jobusco.com/public/images/logo.png',
        },
        networks: [
          { network: 'twitter', name: 'Twitter', icon: 'fab fa-twitter' },
          { network: 'facebook', name: 'Facebook', icon: 'fab fa-facebook-f' },
          { network: 'linkedin', name: 'Linkedin', icon: 'fab fa-linkedin' },
        ],
        // == ==
      }
    },
    watch:{
      '$route.params.id':function(val)
      {
        this.id=this.$route.params.id;
        this.getData();
      },

    },

    methods:{
      getData(){

        axios.get(tools.url("/vacanctFront/"+this.id))
        .then((response)=>{
            this.vacanct = response.data;
            // *** VUE-META & SHARING PLUGIN ***
            this.sharing.url = this.urlPage+this.$route.params.id //Full URL para SHARING PLUGIN
            this.sharing.title = this.vacanct.nombre; // Title para VUE-META y SHARING PLUGIN
    
            this.sharing.description = this.vacanct.descripcion; // En caso de descripcion para VUE-META. NO usar para el plugin de compartir. Twitter tiene limites de caracteres
            this.sharing.keywords = 'jobusco,empleos'; // En caso de keywords para el VUE-META
            this.sharing.media = this.vacanct.empresa_imageUrl; // En caso de imagen para el VUE-META y SHARING PLUGIN
            // *** fin ***

          }).catch((error)=>{

          });
      },
      savePostulate(){
          if (this.$root.type_logged != null) {
              if (this.$root.type_logged == 'usuario') {
                  if(this.vacanct.aplicar_antesde < this.day_now){
                    this.modal.icon = 'error';
                    this.modal.msg = 'Se ha superado la fecha limite de postulacion de la vacante';
                    this.$refs.modalAlert.open();
                    return;
                  }
                  this.$refs.modalLoading.open();
                  var dataform = {
                      vacancies_id:this.id,
                      usuarios_id:this.$root.user.usuarios_id
                  };

                  axios.post(tools.url("/savePostulateFront"),dataform)
                  .then((response)=>{
                    this.$refs.modalLoading.close();
                    this.modal.icon = 'success';
                    this.modal.msg = 'Postulacion guardada correctamente';
                    this.$refs.modalAlert.open();
                  }).catch((error)=>{
                    this.$refs.modalLoading.close();
                    this.modal.icon = 'error';
                    this.modal.msg = 'Ocurrio un error la guardar';
                    this.$refs.modalAlert.open();
                  });
              }
          }
          else{
              this.modal.icon = 'warning';
              this.modal.msg = 'No puedes postularte hasta estar registrado o haber iniciado sesion';
              this.$refs.modalAlert.open();
          }

      },
      onSubmitContact(event){
        event.preventDefault();
        this.contactForm.company_id = this.vacanct.usuarios_id;
        this.contactForm.empleos_id = this.id
        axios.post(tools.url("/companyFrontStoreMsg"),this.contactForm)
        .then((response)=>{
              this.contactForm = {};

              this.modal.icon = 'success'
              this.modal.msg = 'Gracias, su mensaje ha sido enviado!';
              this.$refs.modalAlert.open();
          }).catch((error)=>{
              this.modal.icon = 'error'
              this.modal.msg = 'Ocurrio un error al guardar!';
              this.$refs.modalAlert.open();
          });
      },
      saveVacancies(){
          if (this.$root.type_logged != null) {
              if (this.$root.type_logged == 'usuario') {
                  var dataform = {
                      empleos_id:this.id,
                      usuarios_id:this.$root.user.usuarios_id
                  };
                  axios.post(tools.url("/api/admin/saveUsuarioVacant"),dataform)
                  .then((response)=>{
                      this.contactForm = {};

                      this.modal.icon = 'success'
                      this.modal.msg = 'Empleo guardado correctamente!';
                      this.$refs.modalAlert.open();
                  }).catch((error)=>{
                      this.modal.icon = 'error'
                      this.modal.msg = 'Ocurrio un error al guardar!';
                      this.$refs.modalAlert.open();
                  });
              }
              else{
              this.modal.icon = 'warning';
              this.modal.msg = 'No puedes guardar la vacante hasta estar registrado o haber iniciado sesion';
              this.$refs.modalAlert.open();
          }
          }
          else{
              this.modal.icon = 'warning';
              this.modal.msg = 'No puedes guardar la vacante hasta estar registrado o haber iniciado sesion';
              this.$refs.modalAlert.open();
          }
      },
      storeView(){
        axios.get(tools.url("/vacantStoreViewFront/"+this.id))
          .then((response)=>{

        }).catch((error)=>{

        });
      },

    },
    mounted(){

      var now = new Date();
      var month = (now.getMonth() + 1);               
      var day = now.getDate();
      if (month < 10) {
          month = "0" + month;
        }
      if (day < 10) {
          day = "0" + day;
        }
      this.day_now = now.getFullYear() + '-' + month + '-' + day;

      if(this.$route.params.id){
        this.id=this.$route.params.id;
        this.getData();
        this.storeView();
      }
    }
  }
</script>
<style type="text/css">
  .btn-q{
        border-radius: 2px;
    color: #16b1ab;
    cursor: pointer;
    display: inline-block;
    margin: 1px 4px;
    position: relative;
    transition: all .25s ease-in-out;
    font-size: 20px;
  }
</style>
